import { render } from "./History.vue?vue&type=template&id=468200d1&scoped=true"
import script from "./History.vue?vue&type=script&lang=js"
export * from "./History.vue?vue&type=script&lang=js"

import "./History.vue?vue&type=style&index=0&id=468200d1&scoped=true&lang=css"

import exportComponent from "D:\\Work\\renny\\rotto-sale\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-468200d1"]])

export default __exports__